import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { useUser } from '@/contexts/UserContext';
import AddressIcon from '@/svg-icons/address';

function AddressSection({ address }) {
  const me = useUser();
  const isColombianFranchisee = me?.profile?.country === 'CO';

  if (!address) return null;

  return (
    <div className="w-full" data-cy="order-details-address">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
        <AddressIcon className="text-gray-700 mr-2 w-6 h-6 shrink-0" />
        <FormattedMessage id="address" />
      </div>

      <div className="flex flex-col text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
        {!isColombianFranchisee && address.zipcode && (
          <div className="mb-[1vw]" data-cy="order-details-address-zipcode">
            {address.zipcode}
          </div>
        )}

        <div className="mb-[1vw]" data-cy="order-details-address-street-number-complement">
          {address.street}, {address.number}
          {address.complement && (
            <span>
              <span>, </span>
              {address.complement}
            </span>
          )}
        </div>
        
        <div data-cy="order-details-address-neighborhood-city-state">
          {address.neighborhood}, {address.city} - {address.state}
        </div>
      </div>
    </div>
  );
}

AddressSection.propTypes = {
  address: PropTypes.object.isRequired,
};

export default AddressSection;
